module.exports = __webpack_public_path__ + "static/media/right-arrow-white.86aa83f3.svg";